/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DivisionDto as DigiworkMaitreDPosDtoDivisionDto } from '../../models/Digiwork/MaitreD/Pos/DTO/division-dto';
import { AddDivisionDto as DigiworkMaitreDPosDtoDivisionsAddDivisionDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Divisions/add-division-dto';

export interface AddDivision$Params {
      body?: DigiworkMaitreDPosDtoDivisionsAddDivisionDto
}

export function addDivision(http: HttpClient, rootUrl: string, params?: AddDivision$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>> {
  const rb = new RequestBuilder(rootUrl, addDivision.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoDivisionDto>;
    })
  );
}

addDivision.PATH = '/api/divisions';
